// extracted by mini-css-extract-plugin
export default {"validation-message":"SzmBLq0wkTyDFHTmVvOw"};